export default {
	verifying: "Verificando...",
	success: "Email Verificado!",
	successDesc: "Sua conta foi ativada com sucesso. Você já pode fazer login.",
	goToLogin: "Ir para Login",
	checkEmail: "Verifique seu Email",
	sentTo: "Enviamos um link de verificação para {email}",
	checkSpam: "Não encontrou? Verifique a pasta de spam.",
	resend: "Reenviar Email",
	resendSuccess: "Email reenviado com sucesso!",
	error: "Erro na Verificação",
	invalidToken: "Token inválido ou expirado. Solicite um novo.",
};
